export enum RegisterTypes {
  SET_DRAFT = '@register/SET_DRAFT',
  CLEAR_REGISTER = '@register/CLEAR_REGISTER',
  FETCH_COMPANY_REQUEST = '@register/FETCH_COMPANY_REQUEST',
  FETCH_COMPANY_SUCCESS = '@register/FETCH_COMPANY_SUCCESS',
  FETCH_COMPANY_FAILURE = '@register/FETCH_COMPANY_FAILURE',
  CHECK_EMAIL_REQUEST = '@register/CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_SUCCESS = '@register/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE = '@register/CHECK_EMAIL_FAILURE',
}
export interface RequestState {
  fetch_company: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  check_email: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export type RegisterDraft = {
  fullName: string;
  cnpj: string;
  telephone: string;
  email: string;
  password: string;
};

export type CompanyData = {
  razao_social: string;
  beginner: boolean;
};

export interface RegisterState {
  draft: RegisterDraft | null;
  company: CompanyData | null;
  user_exists: boolean | null;
  request: RequestState;
}
